/**
 * assets/ga4-ecommerce.js
 * Gedrag van snippets/ga4-ecommerce.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function() {
  'use strict';

  /* Server-side paginacontext uit het JSON-eiland #ga4-page-context hierboven.
     Alles wat Liquid moet weten staat daar; het gedrag staat hier.
     Zie ARCHITECTURE.md sectie 11. */
  var CTX = {};
  try {
    var _ctxEl = document.getElementById('ga4-page-context');
    if (_ctxEl) CTX = JSON.parse(_ctxEl.textContent) || {};
  } catch (_e) { CTX = {}; }
  var CURRENCY = CTX.currency || 'EUR';

  /* ═══ Helper: veilig gtag aanroepen ═══ */
  /* Sinds 28-07-2026 stuurt het thema de STANDAARD ecommerce-events niet meer.
     De Google & YouTube-app stuurt page_view, view_item, view_item_list, view_cart,
     add_to_cart, remove_from_cart, search, begin_checkout, add_payment_info,
     add_shipping_info en purchase zelf naar G-9HQRM66093, AW-17999886877 en
     MC-MKF95HJ3E0. GA4 dedupliceert alleen purchase op transaction_id; de rest niet.
     select_item zit NIET in die app-set en blijft dus wel staan.
     Terugzetten: STUUR_STANDAARD_EVENTS op true. */
  var STUUR_STANDAARD_EVENTS = false;
  /* CORRECTIE 31-07-2026 (MEET-1). De aanname hierboven klopte voor negen van de
     elf events, maar NIET voor view_item_list en view_cart. Die stuurt de
     Google-app niet. Gemeten in GA4: view_item_list 1.025 op 27-07, 212 op 28-07
     (halve dag, de deploy was 12:02) en daarna NUL op 29 en 30 juli; view_cart 36,
     dan 9, dan nul. Die twee waren dus nergens meer, niet in GA4 en niet in
     Amplitude, want de Amplitude-bridge in de worker server-side-tracking leest mee
     op de GA4-collect-stroom door deze first-party proxy en mapt view_item_list naar
     collection_viewed en view_cart naar cart_viewed (AMPLITUDE_EVENT_MAP, worker.js
     regel 427).

     Ze staan daarom weer aan. GEEN dubbeltellingsrisico: dat de app ze niet levert
     is empirisch bewezen doordat de teller op nul viel op het moment dat wij stopten.

     NIET ZOMAAR UITBREIDEN. begin_checkout hoort hier NIET bij. Dat event leeft wel
     in GA4 via de Google-app (142 op 29-07, 186 op 30-07) maar mist in Amplitude,
     omdat de server-side route van Google nooit langs deze proxy komt. Dat hoort aan
     de worker-kant opgelost met een Amplitude-only pad. Zet je het hier aan, dan
     komt de dubbeltelling terug die de fix van 28-07 juist oploste.

     Wie hier een event toevoegt of weghaalt: tik eerst de CONSUMENTEN af, niet
     alleen deze file. De keten is thema -> data.vijvercentrum.nl -> worker
     server-side-tracking -> AMPLITUDE_EVENT_MAP -> Amplitude. Niets in de code
     dwingt dat af, dus de dagelijkse wachter meetketen-wacht.js alarmeert als een
     van deze events op nul valt. */
  var EIGEN_EVENTS = ['select_item', 'view_item_list', 'view_cart'];

  function track(eventName, params) {
    if (!STUUR_STANDAARD_EVENTS && EIGEN_EVENTS.indexOf(eventName) === -1) return;
    if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  }

  /* ═══ Helper: Shopify product → GA4 item ═══ */
  /* BRIDGE-ONLY (MEET-2, 04-08-2026)
     Stuurt een event uitsluitend naar de Amplitude-bridge, NIET naar GA4.

     Waarom dit bestaat. De bridge in de worker server-side-tracking leest mee op
     de GA4-collect-stroom door onze first-party proxy data.vijvercentrum.nl en
     mapt via AMPLITUDE_EVENT_MAP. Daardoor zat hij vast aan wat het thema naar
     GA4 stuurt, en dat is twee keer misgegaan. Events die de Google-app zelf al
     server-to-server naar GA4 stuurt mogen wij niet nog eens via gtag sturen,
     want GA4 dedupliceert alleen purchase. Deze route lost dat op: zelfde
     payloadvorm, maar de worker stuurt hem nergens naar Google door.

     Nu in gebruik voor begin_checkout, dat leeft wel in GA4 via de Google-app
     maar niet in Amplitude. Per 17-08-2026 schuiven view_item_list en view_cart
     hier ook naartoe, zodra in GA4 zichtbaar is dat de app ze echt levert
     (herkenbaar aan de parameter shopify_event_name). Zie kaart MEET-2.

     Harde eisen aan deze functie:
     - mag NOOIT de afrekenknop vertragen of breken, vandaar sendBeacon en een
       try/catch om alles heen;
     - faalt dicht op privacy: zonder analytics-consent gaat er niets uit;
     - zonder client id heeft het geen zin, want de bridge gooit een event
       zonder identiteit toch weg. */
  var BRIDGE_URL = 'https://data.vijvercentrum.nl/amp/collect';

  function bridgeOnly(eventName, params) {
    try {
      if (!navigator.sendBeacon) return;

      var analytics = false, marketing = false;
      try {
        analytics = !!(window.Shopify && Shopify.customerPrivacy &&
          Shopify.customerPrivacy.analyticsProcessingAllowed());
        marketing = !!(window.Shopify && Shopify.customerPrivacy &&
          Shopify.customerPrivacy.marketingAllowed());
      } catch (e) { analytics = false; }
      if (!analytics) return;

      var m = document.cookie.match(/_ga=GA\d\.\d+\.(\d+\.\d+)/);
      var cid = m ? m[1] : null;
      if (!cid) return;

      params = params || {};
      var sp = new URLSearchParams();
      sp.set('en', eventName);
      sp.set('cid', cid);
      sp.set('gcs', 'G1' + (marketing ? '1' : '0') + '1');
      sp.set('dl', location.href);
      if (document.referrer) sp.set('dr', document.referrer);
      if (CTX.customerId) sp.set('uid', String(CTX.customerId));
      if (params.currency) sp.set('cu', params.currency);
      if (params.value !== null && params.value !== undefined) {
        sp.set('epn.value', String(params.value));
      }

      /* Items in het GA4 collect-formaat prN: velden gescheiden door ~, elk veld
         met een prefix van 2 tekens (id, nm, br, va, ca, pr, qt). De tilde is het
         scheidingsteken, dus die moet uit de waarden. */
      var lijst = params.items || [];
      for (var i = 0; i < lijst.length && i < 20; i++) {
        var it = lijst[i] || {};
        var v = [];
        function veld(pre, waarde) {
          if (waarde === null || waarde === undefined || waarde === '') return;
          v.push(pre + String(waarde).split('~').join(' '));
        }
        veld('id', it.item_id);
        veld('nm', it.item_name);
        veld('br', it.item_brand);
        veld('va', it.item_variant);
        veld('pr', it.price);
        veld('qt', it.quantity);
        if (v.length) sp.set('pr' + (i + 1), v.join('~'));
      }

      navigator.sendBeacon(BRIDGE_URL + '?' + sp.toString());
    } catch (e) {
      /* Meten mag de winkel nooit breken. Stil falen is hier het juiste gedrag. */
    }
  }

  function mapItem(product, variant, index) {
    /* item_id volgt het purchase-formaat van de Google/Shopify checkout-
       koppeling (shopify_NL_<product_id>_<variant_id>) zodat GA4 deze
       events aan dezelfde items koppelt als het purchase-event. */
    var idVariant = variant || (product.variants && product.variants[0]) || null;
    var item = {
      item_id: (idVariant && idVariant.id) ? 'shopify_NL_' + product.id + '_' + idVariant.id : (product.id || '').toString(),
      item_name: product.title || '',
      price: 0,
      index: index || 0
    };
    if (variant) {
      item.item_variant = variant.title || '';
      item.price = parseFloat(variant.price) / 100 || 0;
    } else if (product.price) {
      item.price = parseFloat(product.price) / 100 || 0;
    }
    if (product.vendor) item.item_brand = product.vendor;
    if (product.type) item.item_category = product.type;
    return item;
  }

  /* ═══ 1. VIEW_ITEM, Productpagina ═══ */
  if (CTX.pageType === 'product' && CTX.product) {
  (function() {
    var product = CTX.product;
    var variant = product.variants && product.variants[0];
    var selectedVariant = CTX.selectedVariant;
    if (selectedVariant) variant = selectedVariant;

    track('view_item', {
      currency: CURRENCY,
      value: parseFloat(variant ? variant.price : product.price) / 100 || 0,
      items: [mapItem(product, variant, 0)]
    });
  })();
  }

  /* ═══ 2. VIEW_ITEM_LIST + SELECT_ITEM, Collectiepagina ═══ */
  if (CTX.pageType === 'collection' && CTX.collection) {
  (function() {
    var LIST_ID = CTX.collection.handle;
    var LIST_NAME = CTX.collection.title;

    /* Eén bron van waarheid: het data-ga4-item attribuut dat
       snippets/product-card.liquid op elke kaart rendert. Daardoor werkt
       dit ook voor kaarten die later via load-more of filter-AJAX in de
       grid komen. item_id volgt het purchase-formaat van de checkout-
       koppeling: shopify_NL_<product_id>_<variant_id>. */
    function cardItem(card) {
      try {
        return JSON.parse(card.getAttribute('data-ga4-item'));
      } catch (err) {
        return null;
      }
    }

    function gridCards() {
      return document.querySelectorAll('[data-product-grid-inner] [data-ga4-item]');
    }

    /* view_item_list: de grid zoals gerenderd bij paginaweergave
       (maximaal 20 items, zelfde plafond als voorheen) */
    var cards = gridCards();
    var items = [];
    for (var i = 0; i < cards.length && items.length < 20; i++) {
      var it = cardItem(cards[i]);
      if (it) {
        it.index = i;
        items.push(it);
      }
    }
    if (items.length > 0) {
      track('view_item_list', {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: items
      });
    }

    /* select_item: gedelegeerde click-listener op document (capture),
       overleeft dus het vervangen van de grid door load-more en
       filter-AJAX. transport_type beacon zodat het event de navigatie
       naar de productpagina overleeft. */
    document.addEventListener('click', function(e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest('[data-ga4-item]');
      if (!card || !card.closest('[data-product-grid-inner]')) return;
      /* Carrousel-pijlen en dots op de kaart zijn geen productselectie */
      if (e.target.closest('[data-pc-prev], [data-pc-next], [data-pc-dot]')) return;
      /* Wel een selectie: de productlink of de quick-add knop */
      var isProductLink = e.target.closest('a[href*="/products/"]');
      var isQuickAdd = e.target.closest('form[action*="/cart/add"]');
      if (!isProductLink && !isQuickAdd) return;

      var item = cardItem(card);
      if (!item) return;
      var all = gridCards();
      for (var idx = 0; idx < all.length; idx++) {
        if (all[idx] === card) { item.index = idx; break; }
      }

      track('select_item', {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        transport_type: 'beacon',
        items: [item]
      });
    }, true);
  })();
  }

  /* ═══ 3. ADD_TO_CART, Intercept /cart/add.js ═══ */
  (function() {
    var origFetch = window.fetch;
    if (!origFetch) return;

    window.fetch = function(url, options) {
      var promise = origFetch.apply(this, arguments);

      /* Detecteer /cart/add.js calls */
      if (typeof url === 'string' && url.indexOf('/cart/add') > -1 && options && options.method === 'POST') {
        promise.then(function(response) {
          if (!response.ok) return;
          /* Clone zodat we het lichaam kunnen lezen */
          return response.clone().json().then(function(data) {
            if (!data) return;

            /* data kan een enkel item of { items: [...] } zijn */
            var addedItems = data.items || [data];
            var ga4Items = [];
            var totalValue = 0;

            addedItems.forEach(function(item, i) {
              var price = parseFloat(item.final_line_price || item.price || 0) / 100;
              totalValue += price;
              ga4Items.push({
                item_id: (item.product_id && item.variant_id) ? 'shopify_NL_' + item.product_id + '_' + item.variant_id : (item.sku || (item.variant_id || '').toString()),
                item_name: item.product_title || item.title || '',
                item_variant: item.variant_title || '',
                item_brand: item.vendor || '',
                price: parseFloat(item.price || 0) / 100,
                quantity: item.quantity || 1,
                index: i
              });
            });

            track('add_to_cart', {
              currency: data.currency || CURRENCY,
              value: totalValue,
              items: ga4Items
            });
          }).catch(function() { /* stil falen */ });
        }).catch(function() { /* stil falen */ });
      }

      return promise;
    };
  })();

  /* ═══ Gedeelde winkelwagen-helpers ═══ */
  /* Eén bron van waarheid voor de winkelwagen: /cart.js, niet een server-side
     snapshot uit Liquid. De cache wordt bij het laden gevuld en na elke mutatie
     ververst via cart:refresh, zodat begin_checkout meteen kan vuren zonder op
     een fetch te wachten. view_cart haalt bewust wél vers op, want dat event
     volgt direct op een mutatie en de cache kan dan nog onderweg zijn. */
  var cachedCart = null;

  function refreshCartCache() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { cachedCart = data; return data; })
      .catch(function () { return null; });
  }

  refreshCartCache();
  document.addEventListener('cart:refresh', refreshCartCache);

  /* Zet een /cart.js-respons om naar GA4-items. item_id volgt het
     purchase-formaat van de checkout-koppeling: shopify_NL_<product_id>_<variant_id>. */
  function mapCartItems(cart) {
    var items = [];
    var totalValue = 0;
    (cart.items || []).forEach(function (item, i) {
      var regelTotaal = parseFloat(item.final_line_price || item.price || 0) / 100;
      totalValue += regelTotaal;
      items.push({
        item_id: (item.product_id && item.variant_id) ? 'shopify_NL_' + item.product_id + '_' + item.variant_id : (item.sku || (item.variant_id || '').toString()),
        item_name: item.product_title || item.title || '',
        item_variant: item.variant_title || '',
        item_brand: item.vendor || '',
        price: parseFloat(item.price || 0) / 100,
        quantity: item.quantity || 1,
        index: i
      });
    });
    return { items: items, totalValue: totalValue };
  }

  /* ═══ 4. BEGIN_CHECKOUT, Klik op afrekenen ═══ */
  /* Uses sendBeacon + async fetch so the main thread is never blocked.
     sendBeacon ensures GA4 data arrives even during page unload. */
  (function() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href*="/checkout"]');
      if (!link) return;

      var cart = cachedCart;
      if (!cart || !cart.items || cart.items.length === 0) return;

      var mapped = mapCartItems(cart);
      var items = mapped.items;
      var totalValue = mapped.totalValue;

      /* begin_checkout gaat NIET via track(). De Google & YouTube-app stuurt dit
         event zelf server-to-server naar GA4 (gemeten: 142 op 29-07, 186 op
         30-07), dus via gtag sturen zou dubbeltellen. Maar de Amplitude-bridge
         mist hem daardoor, want de server-side route van Google komt nooit langs
         onze proxy. Vandaar bridgeOnly: wel naar Amplitude, niet naar GA4.
         Dit herstelt checkout_started, dat sinds 28-07 12:02 op nul stond. */
      var bcPayload = {
        currency: cart.currency || CURRENCY,
        value: totalValue,
        items: items
      };
      track('begin_checkout', bcPayload);
      bridgeOnly('begin_checkout', bcPayload);
    }, true);
  })();

  /* ═══ 5. VIEW_CART, Cart drawer/pagina ═══ */
  /* view_cart vuurt op twee momenten, allebei met verse data uit /cart.js:
     de winkelwagenpagina en het openen van de cart-drawer.

     WAAROM DE DRAWER ERBIJ MOET. Tot 16-08-2026 vuurde dit event alleen op
     /cart, en dat pad loopt vrijwel niemand: het thema gebruikt een drawer die
     na elke toevoeging opengaat. Gemeten over 14 dagen: add_to_cart 5.642,
     begin_checkout 3.455, view_cart 206. Die 206 hoort tussen de andere twee in
     te liggen, dus de funnelstap ontbrak in de praktijk in zowel GA4 als
     Amplitude (waar hij als cart_viewed binnenkomt).

     LET OP BIJ DE EERSTVOLGENDE MEETCONTROLE: het volume van view_cart en
     cart_viewed springt hierdoor van enkele tientallen per dag naar dezelfde
     orde als add_to_cart. Dat is de bedoeling, geen storing.

     De oude implementatie las een server-side Liquid-snapshot van de
     winkelwagen. Die was op /cart correct (die pagina post en herlaadt), maar
     hij kon per definitie niet meebewegen met de drawer. Het JSON-eiland
     #ga4-page-context bevat daarom geen cart-blok meer. */
  (function () {
    function stuurViewCart() {
      refreshCartCache().then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        var mapped = mapCartItems(cart);
        track('view_cart', {
          currency: cart.currency || CURRENCY,
          value: mapped.totalValue,
          items: mapped.items
        });
      });
    }

    if (CTX.pageType === 'cart') stuurViewCart();
    document.addEventListener('cart:open', stuurViewCart);
  })();

  /* ═══ 6. REMOVE_FROM_CART, Listens to cart:remove custom event ═══ */
  (function() {
    document.addEventListener('cart:remove', function(e) {
      if (e.detail && e.detail.item) {
        var item = e.detail.item;
        track('remove_from_cart', {
          currency: CURRENCY,
          value: parseFloat(item.price || 0) / 100,
          items: [{
            item_id: (item.product_id && item.variant_id) ? 'shopify_NL_' + item.product_id + '_' + item.variant_id : (item.sku || (item.variant_id || '').toString()),
            item_name: item.product_title || item.title || '',
            item_variant: item.variant_title || '',
            quantity: item.quantity || 1
          }]
        });
      }
    });
  })();

  /* ═══ 7. SEARCH, Zoekresultaten ═══ */
  if (CTX.pageType === 'search' && CTX.searchTerms) {
    track('search', {
      search_term: CTX.searchTerms
    });
  }

})();
